import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "名称",
            span: 8,
            placeholder: '请输入名称',
            model: "name"
        },
    ]
    const tableColumns = [
        {
            label: "事项名称",
            prop: "name",
            align: "center",
            show: true
        },
        {
            label: "开始时间",
            prop: "startTime",
            align: "center",
            show: true
        },
        {
            label: "结束时间",
            prop: "endTime",
            align: "center",
            show: true,
        },
        {
            label: "排序",
            prop: "sort",
            align: "center",
            show: true
        },
        {
            label: "操作",
            name: "contr",
            align: "center",
            width: '200px',
            show: true
        }
    ]
    const formItems = [
        {
            label: "事项名称",
            span: 24,
            model: "name",
            disabled: true,
            labelClass: 'info-label',
        },
        {
            label: "开始时间",
            span: 24,
            model: "startTime",
            type: 'datetime',
            placeholder: '请选择开始时间',
            labelClass: 'info-label',
            pickerOptions: {
                disabledDate(time) {
                    let oneDay = 24 * 60 * 60 * 1000;
                    let time1 = new Date(that.handleData.endTime).getTime() - oneDay;
                    return time.getTime() > time1
                }
            },
        },
        {
            label: "结束时间",
            span: 24,
            model: "endTime",
            type: 'datetime',
            placeholder: '请选择结束时间',
            labelClass: 'info-label',
            pickerOptions: {
                disabledDate(time) {
                    let oneDay = 24 * 60 * 60 * 1000;
                    let time1 = new Date(that.handleData.startTime).getTime() + oneDay;
                    return time.getTime() < time1
                }
            },
        },
    ]

    const formRules = {
        startTime: [{
            required: true,
            trigger: "blur",
            message: '请选择开始时间'
        }],
        endTime: [{
            required: true,
            trigger: "blur",
            message: '请选择结束时间'
        }],
    }
    return {
        searchItems,
        tableColumns,
        formItems,
        formRules
    }
}
